export default __webpack_public_path__ + "static/media/undo-variant.42a48492.svg";